import React from 'react';

import { Box } from '@chakra-ui/react';
import { useDispatch } from 'react-redux';
import { setReviewerViewSettings, useReviewersSettings } from 'reducers/reviewCreationSlice';

import { ManagerRabbit1 } from 'assets/assetsV1/iconComponents';

import {
  ExpandablePaper,
  ExpandablePaperBody,
  ExpandablePaperHeader,
} from 'uiToolkitV1/ExpandablePaper/ExpandablePaper';
import { RadioSelect } from 'uiToolkitV1/RadioSelect';
import { TextBodyMedium } from 'uiToolkitV1/Typography';

export const ManagerSettings = ({ feedbackFormId }) => {
  const dispatch = useDispatch();
  const { isAllowManagerFormFillingBeforeSelf } = useReviewersSettings({
    feedbackFormId,
  });

  const onChangeHandler = (newValueBool) => {
    dispatch(
      setReviewerViewSettings({
        feedbackFormId,
        settings: { isAllowManagerFormFillingBeforeSelf: newValueBool },
      })
    );
  };

  return (
    <ExpandablePaper>
      <ExpandablePaperHeader
        title="Manager Settings"
        leftIconComponent={<ManagerRabbit1 boxSize="24px" color="icon.g2" />}
      />
      <ExpandablePaperBody>
        <Box p="10px 8px">
          <TextBodyMedium mr={2} mb="2px">
            Allow managers to start the manager reviews even if the self review has not been submitted yet? (post the
            manager review start date)
          </TextBodyMedium>

          <RadioSelect
            options={[{ name: 'Yes' }, { name: 'No' }]}
            selectedIndex={isAllowManagerFormFillingBeforeSelf ? 0 : 1}
            onChange={(index) => onChangeHandler(index === 0)}
          />
        </Box>
      </ExpandablePaperBody>
    </ExpandablePaper>
  );
};
